import { render, staticRenderFns } from "./ConsumerUnitType.vue?vue&type=template&id=d63112f6&scoped=true"
import script from "./ConsumerUnitType.vue?vue&type=script&lang=js"
export * from "./ConsumerUnitType.vue?vue&type=script&lang=js"
import style0 from "./ConsumerUnitType.vue?vue&type=style&index=0&id=d63112f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63112f6",
  null
  
)

export default component.exports